import { Link as MuiLink } from '@mui/material';
import { styled } from '@mui/system';
import { theme } from '../../lib/index';

export const SocialIcon = styled(MuiLink, {})({
  marginRight: 5,
  width: 19,
  height: 19,

  opacity: 1,

  color: theme.palette.darkgrey,
  textDecoration: 'none',

  transition: 'opacity 250ms ease-in-out',

  '&:hover': {
    opacity: 0.7,

    transition: 'opacity 250ms ease-in-out',
  },
});
